import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Link } from '@material-ui/core'

import {
  Container,
  LoadingFeedback,
  Page,
  Permitted,
  DriveTour,
  InfoCard,
} from 'components'
import { CompanyTrails } from './components'

import qs from 'query-string'

import usePermissions from 'hooks/usePermissions'
import useAuth from 'hooks/useAuth'

import helpers from 'helpers'

import useStyles from './styles'
import constants from 'constants/index'

import { routes } from 'Routes'

const Dashboard = () => {
  const [loading, setLoading] = useState(false)
  const [openTour, setOpenTour] = useState(false)

  const { company } = useAuth()

  const classes = useStyles()
  const history = useHistory()
  const { mixpanel } = helpers
  const { isDpo, permitted } = usePermissions()

  const isOutSourcedDpo = isDpo()

  const filtersMatrixSteps = (elementId, permission) => {
    const requiredPermission =
      constants.myLgpd.DRIVER_STEPS_OBJECT_WITH_PERMISSIONS[elementId]

    return requiredPermission ? permission(requiredPermission) : true
  }

  const filteredSteps = constants.myLgpd.DRIVER_STEPS_OBJECT.filter((step) => {
    return filtersMatrixSteps(step.element, permitted)
  })

  const handleSettingsRedirection = () =>
    history.push({
      pathname: routes.settings,
      search: qs.stringify({
        statusIn: [
          constants.settings.FINANCIAL_OVERDUE_STATUS,
          constants.settings.FINANCIAL_FAILURE_STATUS,
        ],
      }),
      state: { tab: 'financial' },
    })

  const handleOpenTour = () => {
    const where = 'Home'
    const title = 'Tour'

    const params = {
      action: 'tour-home',
    }

    helpers.mixpanel.track(where, title, params)
    setOpenTour(true)
  }
  // Comentado caso o redirecionando queira ser para o dashBoard.
  // useEffect(() => {
  //   if (isOutSourcedDpo) {
  //     history.push(routes.myLgpd.dashboard)
  //   }

  //   //eslint-disable-next-line
  // }, [isOutSourcedDpo])

  // if (isOutSourcedDpo) {
  //   return <></>
  // }

  return (
    <Page className={classes.root} title="DPOnet - Início">
      <Container
        maxWidth={false}
        spacingXl={8}
        spacingLg={8}
        spacingMd={5}
        spacingSm={5}
      >
        {company?.haveOverdueOrders && (
          <Permitted tag={constants.permissions.PAYMENT_ORDERS.LIST}>
            <InfoCard
              title="Detectamos um problema com o pagamento da sua fatura. Por favor,
        regularize-o para evitar a interrupção do seu acesso."
              endActions={
                <Link
                  variant="body1"
                  color="initial"
                  underline="always"
                  className={classes.link}
                  onClick={handleSettingsRedirection}
                >
                  Ver faturas
                </Link>
              }
            />
          </Permitted>
        )}
        <CompanyTrails
          setLoading={setLoading}
          handleOpenTour={handleOpenTour}
        />
      </Container>

      <LoadingFeedback open={loading} />
      <DriveTour
        stepsMatrix={filteredSteps}
        customStyle={classes.customPopover}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default Dashboard
